/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Momentjs used to show and hide phone number between 8am and 4pm - Michael 9-5-2019
  // Resource: https://momentjs.com/docs/#/get-set/hour/
  var momentHour = moment().hour();
  var momentMinute = moment().minute();
  var momentDay = moment().weekday();

  // momentMinute counts up from 0 to 59, this pre-pends a 0 if it's less than 9 minutes - Michael 2-7-2020
  if (momentMinute <= 9) {
    momentMinute = "0" + momentMinute;
  }

  var momentTime = momentHour + "" + momentMinute;

  // console.log ("Hours: " + momentHour);
  // console.log ("Minutes: " + momentMinute);
  // console.log("Current Time: " + momentTime);

  if (
    momentTime >= 830 &&
    momentTime <= 1630 &&
    momentDay >= 1 &&
    momentDay <= 5
  ) {
    // $('.momentjs-phone').show();
    // Do nothing
  } else {
    // $('.momentjs-phone').hide();
    // $(".phone-wrapper").addClass("momentjs-phone");
    phoneWrapper();
  }

  function phoneWrapper() {
    // var element = document.getElementById("phone-wrapper-footer");
    // element.classList.add("momentjs-phone");
    const idsToTarget = ['phone-wrapper-desktop', 'phone-wrapper-mobile', 'phone-wrapper-footer']; // Array of IDs
    idsToTarget.forEach(id => {
      const element = document.getElementById(id);
      if (element) { // Check if element exists before attempting to add class
      element.classList.add('momentjs-phone');
      }
    });
  }
  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
